export default __webpack_public_path__ + "static/media/KAIROS_AURA_logo.1f1844c6.png";